var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var ProductFactory = (function () {
    function ProductFactory() {
    }
    ProductFactory.fromApiResponse = function (product) {
        return __assign({ product_id: product.id, product_name: product.name, in_stock: product.is_in_stock, in_stock_subscription: product.is_in_stock_subscription }, product);
    };
    return ProductFactory;
}());
export default ProductFactory;
//# sourceMappingURL=ProductFactory.js.map